import img206001 from "src/assets/images/kwaii/206001.png";
import img206002 from "src/assets/images/kwaii/206002.png";
import img206003 from "src/assets/images/kwaii/206003.png";
import img206004 from "src/assets/images/kwaii/206004.png";
import img206005 from "src/assets/images/kwaii/206005.png";
import img206006 from "src/assets/images/kwaii/206006.png";
import img206007 from "src/assets/images/kwaii/206007.png";
import img206008 from "src/assets/images/kwaii/206008.png";
import img206009 from "src/assets/images/kwaii/206009.png";
import img206010 from "src/assets/images/kwaii/206010.png";

export default {
  206001: {
    name: "Woodie",
    description:
      "A magical creature with wood log body parts that make a perfect trunk disguise. Its favorite foods are the Floral Biscuits and Brownberries. Feeding Woodie when it is hungry will reward players with eggs that can be turned into wood.",
    img: img206001,
    output: [207001],
    input: [202005, 202009],
    gen: 0,
  },
  206002: {
    name: "Metalfox",
    description:
      "A magical creature that seems like a fluffy fox at first glance but covered with fur that is hard as steel. It only feeds on Silvereys and Parples. As long as it is well taken care of and produces eggs, Metalfox eggs can be used to produce metal.",
    img: img206002,
    output: [207002],
    input: [202004, 202010],
    gen: 0,
  },
  206003: {
    name: "Rockie",
    description:
      "Always full of energy unless it's hungry, healthy Rockie would hop everywhere as a way to exercise. Its dream is to become a rockstar with a perfect body, and only accepts Eboneys and Silvereys as its diet food. A well-cared Rockie can occasionally lay eggs that can be converted into stone.",
    img: img206003,
    output: [207003],
    input: [202002, 202004],
    gen: 0,
  },
  206004: {
    name: "Cloray",
    description:
      "Cloray is a Magical Creature that looks like a green ray fish. Its fins are constantly flapping to keep it floating in the air on the Kawaii Islands. If properly fed Greenoos or Eboneys from time to time, it can lay eggs that are used to produce cloth.",
    img: img206004,
    output: [207004],
    input: [202007, 202002],
    gen: 0,
  },
  206005: {
    name: "Leathare",
    description:
      "A fluffy creature that loves to eat Brownberries and Heartberries and sleeps all day. If well-fed and taken care of, it will express affection by laying eggs that can be transformed into leather.",
    img: img206005,
    output: [207005],
    input: [202009, 202003],
    gen: 0,
  },
  206006: {
    name: "Hedglass",
    description:
      "Hedglass is a magical creature that looks like a hedgehog with dazzling clear crystal spikes. There is nothing on Kawaii Islands that it enjoys eating more than Skyberries and Greenoos. In an environment where it feels safe, full and comfortable, Hedglass will lay eggs that can be used to produce shiny pieces of glass.",
    img: img206006,
    output: [207006],
    input: [202008, 202007],
    gen: 0,
  },
  206007: {
    name: "Rubbie",
    description:
      "This bouncy creature looks like a balloon seal with pointy ears. It has quite a bubbly personality, and is totally a sucker for Pinkberries and Parples. If well-fed and properly looked after, it will lay eggs that can be converted into rubber.",
    img: img206007,
    output: [207007],
    input: [202011, 202010],
    gen: 0,
  },
  206008: {
    name: "Cellyfish",
    description:
      "An adorable, delightful creature that looks like a jellyfish with a smiley face and cotton candy ears. Always cheerful and energetic, Cellyfish would lay eggs that could be converted into ceramic if properly provided with its favorite food Snowberries and Goldberries.",
    img: img206008,
    output: [207008],
    input: [202001, 202006],
    gen: 0,
  },
  206009: {
    name: "Clayshelly",
    description:
      "Shy Clayshelly is a creature that always hides itself inside a clay shell. Clayshelly only cares about 2 things in Kawaii Islands floating world: gossips and its favorite fruits, Heartberries and Floral Biscuits. In ideal conditions with on time feeding, it can lay eggs that are used to produce bricks, an important material in crafting items.",
    img: img206009,
    output: [207009],
    input: [202003, 202005],
    gen: 0,
  },
  206010: {
    name: "Plasto",
    description:
      "A magical creature with a laid-back, easy-going personality. Its wide smile can easily put our minds at ease. If properly provided with its favorite food Goldberries and Skyberries, it would lay eggs that can be used in making plastic.",
    img: img206010,
    output: [207010],
    input: [202006, 202008],
    gen: 0,
  },
  206101: {
    name: "Woodie",
    description:
      "A magical creature with wood log body parts that make a perfect trunk disguise. Its favorite foods are the Floral Biscuits and Brownberries. Feeding Woodie when it is hungry will reward players with eggs that can be turned into wood.",
    img: img206001,
    output: [207001],
    input: [202005, 202009],
    gen: 1,
  },
  206102: {
    name: "Metalfox",
    description:
      "A magical creature that seems like a fluffy fox at first glance but covered with fur that is hard as steel. It only feeds on Silvereys and Parples. As long as it is well taken care of and produces eggs, Metalfox eggs can be used to produce metal.",
    img: img206002,
    output: [207002],
    input: [202004, 202010],
    gen: 1,
  },
  206103: {
    name: "Rockie",
    description:
      "Always full of energy unless it's hungry, healthy Rockie would hop everywhere as a way to exercise. Its dream is to become a rockstar with a perfect body, and only accepts Eboneys and Silvereys as its diet food. A well-cared Rockie can occasionally lay eggs that can be converted into stone.",
    img: img206003,
    output: [207003],
    input: [202002, 202004],
    gen: 1,
  },
  206104: {
    name: "Cloray",
    description:
      "Cloray is a Magical Creature that looks like a green ray fish. Its fins are constantly flapping to keep it floating in the air on the Kawaii Islands. If properly fed Greenoos or Eboneys from time to time, it can lay eggs that are used to produce cloth.",
    img: img206004,
    output: [207004],
    input: [202007, 202002],
    gen: 1,
  },
  206105: {
    name: "Leathare",
    description:
      "A fluffy creature that loves to eat Brownberries and Heartberries and sleeps all day. If well-fed and taken care of, it will express affection by laying eggs that can be transformed into leather.",
    img: img206005,
    output: [207005],
    input: [202009, 202003],
    gen: 1,
  },
  206106: {
    name: "Hedglass",
    description:
      "Hedglass is a magical creature that looks like a hedgehog with dazzling clear crystal spikes. There is nothing on Kawaii Islands that it enjoys eating more than Skyberries and Greenoos. In an environment where it feels safe, full and comfortable, Hedglass will lay eggs that can be used to produce shiny pieces of glass.",
    img: img206006,
    output: [207006],
    input: [202008, 202007],
    gen: 1,
  },
  206107: {
    name: "Rubbie",
    description:
      "This bouncy creature looks like a balloon seal with pointy ears. It has quite a bubbly personality, and is totally a sucker for Pinkberries and Parples. If well-fed and properly looked after, it will lay eggs that can be converted into rubber.",
    img: img206007,
    output: [207007],
    input: [202011, 202010],
    gen: 1,
  },
  206108: {
    name: "Cellyfish",
    description:
      "An adorable, delightful creature that looks like a jellyfish with a smiley face and cotton candy ears. Always cheerful and energetic, Cellyfish would lay eggs that could be converted into ceramic if properly provided with its favorite food Snowberries and Goldberries.",
    img: img206008,
    output: [207008],
    input: [202001, 202006],
    gen: 1,
  },
  206109: {
    name: "Clayshelly",
    description:
      "Shy Clayshelly is a creature that always hides itself inside a clay shell. Clayshelly only cares about 2 things in Kawaii Islands floating world: gossips and its favorite fruits, Heartberries and Floral Biscuits. In ideal conditions with on time feeding, it can lay eggs that are used to produce bricks, an important material in crafting items.",
    img: img206009,
    output: [207009],
    input: [202003, 202005],
    gen: 1,
  },
  206110: {
    name: "Plasto",
    description:
      "A magical creature with a laid-back, easy-going personality. Its wide smile can easily put our minds at ease. If properly provided with its favorite food Goldberries and Skyberries, it would lay eggs that can be used in making plastic.",
    img: img206010,
    output: [207010],
    input: [202006, 202008],
    gen: 1,
  },
};
